import React from 'react';
import FetchAndSpeech from './FetchAndSpeech';
import Layout from '../shop/layout';
import { SpeechProvider } from '@speechly/react-client';

import './style.css';


function SpeechIndex() {
  return (
    <>
    <div className='mt-32 text-center font-bold text-2xl'>
        Product Search by Your Voice</div>
    {/* This app id from speechly dashboard */}
    <SpeechProvider appId="5e870479-fec1-43fd-9839-965b064300d2">
    <Layout children={<FetchAndSpeech />} />
    </SpeechProvider>
    </>
  );
}

export default SpeechIndex;